import { render, staticRenderFns } from "./exitPermits.vue?vue&type=template&id=2efad8f3&scoped=true"
import script from "./exitPermits.vue?vue&type=script&lang=js"
export * from "./exitPermits.vue?vue&type=script&lang=js"
import style0 from "./exitPermits.vue?vue&type=style&index=0&id=2efad8f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efad8f3",
  null
  
)

export default component.exports